import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import GoalPage from '../pages/GoalPage.vue';
import ProjectPage from '../pages/ProjectPage.vue';
import ProjectBoardPage from '../pages/ProjectBoardPage.vue';
import HomeTasksPage from '../pages/HomeTasksPage.vue';
import HomeGoalsPage from '../pages/HomeGoalsPage.vue';
import HomeSettingsPage from '../pages/HomeSettingsPage.vue';
import HomeApprovementsPage from '../pages/HomeApprovementsPage.vue';
import HomeNotificationsPage from '../pages/HomeNotificationsPage.vue';
import NotFoundPage from '../pages/NotFoundPage.vue';
import TasksPage from '@/pages/TasksPage.vue';
import NumericsPage from '@/pages/NumericsPage.vue';
import HomeNumericsPage from '@/pages/HomeNumericsPage.vue';

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'home',
        components: { default: HomeTasksPage },
    },
    {
        path: '/home/tasks',
        name: 'user.tasks',
        components: { default: HomeTasksPage },
    },
    {
        path: '/home/goals',
        name: 'user.goals',
        components: { default: HomeGoalsPage },
    },
    {
        path: '/home/notifications',
        name: 'user.notifications',
        components: { default: HomeNotificationsPage },
    },
    {
        path: '/home/approvements',
        name: 'user.approvements',
        components: { default: HomeApprovementsPage },
    },
    {
        path: '/home/numerics',
        name: 'user.numerics',
        components: { default: HomeNumericsPage },
    },
    {
        path: '/home/settings',
        name: 'user.settings',
        components: { default: HomeSettingsPage },
    },
    {
        path: '/projects/:projectId',
        name: 'project.view',
        components: { default: ProjectPage },
    },
    {
        path: '/projects/:projectId/boards/:boardId',
        name: 'projects.board',
        components: { default: ProjectBoardPage },
    },
    {
        path: '/goals/:goalId',
        name: 'goals.view',
        components: { default: GoalPage },
    },
    {
        path: '/tasks',
        name: 'tasks.list',
        components: { default: TasksPage },
    },
    {
        path: '/numerics',
        name: 'numerics.list',
        components: { default: NumericsPage },
    },
];

routes.push({
    path: '/:catchAll(.*)',
    name: 'not-found',
    components: { default: NotFoundPage },
});

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

export default router;
